<template>
  <div id="app" :class="loadedPage">
    <div class="inner-app">
      <transition  @enter="enter" @leave="leave" appear mode="out-in">
        <router-view/>
      </transition>
      <menucomponent></menucomponent>
    </div>
    <footercomponent></footercomponent>
  </div>
</template>

<script>
import { TimelineMax, Power4, Expo } from 'gsap';
import FooterComponent from '@/components/Modules/FooterComponent';
import MenuComponent from '@/components/Modules/MenuComponent';
import store from './store/store';

export default {
  name: 'App',
  methods: {
    homeSlider(payload) {
      store.commit('homeSlider', payload);
    },
    enter(el, done) {
      store.commit('loadedPage', this.currentpage);
      const that = this;
      const tl = new TimelineMax();
      const logoPaths = document.querySelectorAll('.a11, .a12, .a21, .a22, .s1, .s2');
      tl.set('footer', { autoAlpha: 0 }, 0);
      tl.set('#menu-wrapper', { autoAlpha: 0 }, 0);
      if (this.loadedPage === 'home') {
        tl.set('.page-content', { autoAlpha: 1 }, 0);
        tl.set('.slider', { autoAlpha: 0, scale: 1.05 }, 0);
        tl.set('.headerline', { scaleX: 0, transformOrigin: '50% 50%' }, 0);
        tl.set(logoPaths, { scale: 0, transformOrigin: '50% 50%' }, 0);
        tl.to('.headerline', 2, { scaleX: 1, transformOrigin: '50% 50%', ease: Expo.easeInOut }, 0);
        tl.to(logoPaths, 2, { scale: 1, transformOrigin: '50% 50%', ease: Power4.easeInOut }, 1);
        tl.call(that.homeSlider, [true], that, 2.5);
        tl.add(() => {
          document.querySelector('header').classList.add('white');
        }, 2.5);
        tl.to('footer', 1, { autoAlpha: 1 }, 0.5);
        tl.to('#menu-wrapper', 0.3, { autoAlpha: 1 }, 3.2);
        tl.to('.slider', 1.5, { autoAlpha: 1, scale: 1, ease: Power4.easeInOut, onComplete: done }, 2.5);
      } else {
        tl.add(() => {
          store.commit('menuToggle', 'close');
        }, 0);
        tl.set('.page-content', { autoAlpha: 1 }, 0);
        tl.set('.inner-content', { autoAlpha: 0 }, 0);
        tl.set('.headerline', { scaleX: 0, transformOrigin: '0% 50%' }, 0);
        tl.set(logoPaths, { scale: 0, transformOrigin: '50% 50%' }, 0);
        tl.to('.headerline', 1, { scaleX: 1, transformOrigin: '0% 50%', ease: Expo.easeInOut }, 0);
        tl.to(logoPaths, 1, { scale: 1, transformOrigin: '50% 50%', ease: Power4.easeInOut }, 0.3);
        tl.to('footer', 1, { autoAlpha: 1 }, 1.3);
        tl.to('#menu-wrapper', 1, { autoAlpha: 1 }, 1.3);
        tl.to('.inner-content', 1, { autoAlpha: 1, ease: Power4.easeInOut, onComplete: done }, 1.3);
      }
    },
    leave(el, done) {
      const that = this;
      const tl = new TimelineMax();
      const logoPaths = document.querySelectorAll('.a11, .a12, .a21, .a22, .s1, .s2');
      tl.add(() => {
        store.commit('menuToggle', 'close');
      }, 0);
      if (this.loadedPage === 'home') {
        tl.call(that.homeSlider, [false], that, 0.99);
      } else {
        tl.to('.headerline', 1, { scaleX: 0, transformOrigin: '0% 50%', ease: Expo.easeInOut }, 0);
        tl.to(logoPaths, 1, { scale: 0, transformOrigin: '0% 50%', ease: Power4.easeInOut }, 0);
      }
      tl.to('footer', 1, { autoAlpha: 0, ease: Power4.easeOut }, 0.5);
      tl.to('#menu-wrapper', 1, { autoAlpha: 0, ease: Power4.easeOut }, 0.5);
      tl.to('.page-content', 1, { autoAlpha: 0, ease: Power4.easeOut, onComplete: done }, 0.5);
    },
  },
  computed: {
    currentpage() {
      return this.$route.name;
    },
    loadedPage() {
      return store.state.loadedPage;
    },
    currentlang() {
      return store.state.i18n.locale;
    },
  },
  mounted() {
    document.querySelector('html').setAttribute('lang', this.currentlang);
    store.commit('menuToggle', 'close');
  },
  components: {
    footercomponent: FooterComponent,
    menucomponent: MenuComponent,
  },
  watch: {
    $route() {
      store.commit('menuToggle', 'close');
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/resets.scss';
@import '~@/styles/fonts.scss';
@import '~@/styles/mixins.scss';
@import '~@/styles/typo.scss';
@import '~@/styles/swiper.scss';
#app {
  position: relative;
  height: 100%;
}
section {
  padding: 90px 20% 90px 10%;
  @include md {
    padding: 80px 20% 80px 10%;
  }
  @include sm {
    padding: 65px 15% 65px 5%;
  }
  @include xs {
    padding: 50px 15% 50px 5%;
  }
}
#app:not(.home) {
  padding-top: 30px;
  header {
    position: relative;
  }
  @include xs {
    padding-top: 15px;
  }
}
// =====================================================
// Homepage gallery, Single project gallery
// =====================================================
.featured-project {
  display: flex;
  justify-content: space-between;
  align-items: center;
  figure {
    img {
      width: 100%;
    }
  }
  figcaption {
    margin-top: 10px;
    padding: 0 8px;
  }
  p {
    margin-bottom: 0px;
  }
  @include sm {
    flex-direction: column;
    margin-left: 5%;
    margin-right: 15%;
    figure {
      img {
        margin-bottom: 25px;
      }
      figcaption {
        margin-top: 0;
        margin-bottom: 25px;
        padding: 0;
      }
    }
  }
}
.featured-project {
  figure:nth-child(1) {
    width: 33%;
  }
  figure:nth-child(2) {
    width: 25%;
  }
  figure:nth-child(3) {
    width: 40%;
  }
  &.odd {
    figure:nth-child(1) {
      width: 40%;
    }
    figure:nth-child(3) {
      width: 33%;
    }
  }
  @include sm {
    figure:nth-child(1) {
      width: 100%;
    }
    figure:nth-child(2) {
      width: 100%;
    }
    figure:nth-child(3) {
      display: none;
    }
    &.odd {
      figure:nth-child(1) {
        width: 100%;
      }
      figure:nth-child(3) {
        width: 100%;
      }
    }
  }
  @include xs {
    figure:nth-child(2) img {
      display: none;
    }
    figure figcaption {
      margin-bottom: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue